export default "__VITE_ASSET__C6aS__eI__"